<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="saleContainerForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                saleContainerForm: () => import('../forms/SaleContainerForm'),
                headers: [
                    { text: 'Sale', value: 'saleId', table: 'sales', form: () => import('../forms/SaleForm') },
                    { text: 'Seller Container', value: 'sellerContainerId', table: 'containers', form: () => import('../forms/ContainerForm') },
                    { text: 'Buyer Container', value: 'buyerContainerId', table: 'containers', form: () => import('../forms/ContainerForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    containers: [],
                    sales: [],
                    items: []
                },
                sorting: [
                    { column: "saleId", direction: "ascending" },
                    { column: "sellerContainerId", direction: "ascending" },
                ],
                itemsField: 'saleContainers',
                editPageName: 'saleContainer',
                apiMethod: 'SaleContainers',
                claimName: 'SaleContainers',
                formTitle: 'Sale Container',
                excelTitle: 'Sale Containers',
                hasEditPage: false,
            }
        },
    };
</script>
